/* eslint-disable react/prop-types */
import React from 'react';
import useExpression from 'apps/web_forms/hooks/useExpression';

export const FormInputsContext = React.createContext({});

export const FormInputsProvider = ({
  children,
  getValues,
  getInput,
  elements,
  ...rest
}) => {
  const [
    evaluateExpressionChanges,
    evaluateExpression,
    updateGroupElementExpressions,
  ] = useExpression({ getValues, getInput, elements, ...rest });

  return (
    <FormInputsContext.Provider
      value={{
        evaluateExpressionChanges,
        evaluateExpression,
        updateGroupElementExpressions,
        ...rest,
      }}
    >
      {children}
    </FormInputsContext.Provider>
  );
};
